import { render } from "./product.vue?vue&type=template&id=0e40f643&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"

import "./product.vue?vue&type=style&index=0&id=0e40f643&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0e40f643"

export default script